// extracted by mini-css-extract-plugin
export var container = "Contacts-module--container--2II9R";
export var desktopContainer = "Contacts-module--desktopContainer--1cTtn";
export var list = "Contacts-module--list--DTJXH";
export var bookButton = "Contacts-module--bookButton--3Z9lQ";
export var mobileContainer = "Contacts-module--mobileContainer--39sr2";